module.exports = __webpack_public_path__ + "img/sr03_samurai02_shop.ca5e55dc.png";